export enum ExtraVacationsTypes {
  UNPAID = 'Без сохранения зарплаты',
}
